import MapboxAutocompleteField from './MapboxAutocomplete.component';

export default MapboxAutocompleteField;
